import { render, staticRenderFns } from "./data-table.vue?vue&type=template&id=6f1003de&scoped=true&"
import script from "./data-table.vue?vue&type=script&lang=js&"
export * from "./data-table.vue?vue&type=script&lang=js&"
import style0 from "./data-table.vue?vue&type=style&index=0&id=6f1003de&lang=scss&scoped=true&"
import style1 from "./data-table.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1003de",
  null
  
)

export default component.exports